module.exports = __webpack_public_path__ + "img/Cochin-Shipyard-Ltd.f4cde3c5.jpg";